import Idle from '../../lib/idle'

import {getState, dispatch} from '../store'
import makeCurrentUserActive from '../actions/make_current_user_active'
import makeCurrentUserIdle from '../actions/make_current_user_idle'

let idle

export const watchCurrentUserIdle = (uid) => {
  const idleStartTime = getState().getIn(['chatSettings', 'idleStartMinutes']) * 60 * 1000

  idle = new Idle({
    onAway: () => dispatch(makeCurrentUserIdle(uid)),
    onAwayBack: () => dispatch(makeCurrentUserActive(uid)),
    awayTimeout: idleStartTime
  })

  idle.start()
}

export const unwatchCurrentUserIdle = () => {
  if (idle) idle.stop()
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/watchers/current_user_idle.js
 **/